import styled from 'styled-components';
import { Box, TextField } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const CreateOrderFormSection = styled(Box)`
  ${({ theme }) => `display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  .pre-line {
    white-space: pre-line;
    word-break: break-all
  }
  .title {
    ${theme.typography.h4};
    font-weight: 700;
    margin-bottom: 8px;
  }
  .entry {
    display: flex;
    align-items: center;
    .entryTitle {
      font-size : 16px;
      line-height: 24px;
      color: ${colorSet.gray700};    
      min-width: 80px;
    }
    .entryContent {
      font-size : 16px;
      line-height: 24px;
      margin-right: 34px;
    }
    .editableContent {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .MuiFormControl-root {
        width: 100%;
      }
      .entryContent.isClient {
        margin-right: 0px;
      }
      button {
        padding: 0;
        margin: 0;
        font-size: 16px;
        position: 'relative';
        background-color: 'unset';
        margin-left: 10px;
        span {
          color: ${colorSet.primary500};
        }
        svg {
          fill: colorSet.gray600;
          width: 24;
          height: 24;
        }
      }
    }
  }
`}
`;

export const CreateOrderBasicTextField = styled((props) => {
  return <TextField {...props} variant="outlined" size="medium" />;
})``;
